import { zipper, slidingWindow } from "../utils";
import sma from "./sma";
import atr from "./atr";
import { ATRBands as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { windowSize, multiplier, sourcePath } = options;

    // Calculate SMA for the midline
    const smaCalculator = sma().options({ windowSize, sourcePath });

    // Calculate ATR for band width
    const atrCalculator = atr().options({ windowSize });

    // Calculate ATR Bands
    const atrBandsAlgorithm = slidingWindow()
      .windowSize(windowSize)
      .accumulator((values) => {
        const currentSMA = values[values.length - 1].sma;
        const currentATR = values[values.length - 1].atr;

        return {
          top: currentSMA + currentATR * multiplier,
          bottom: currentSMA - currentATR * multiplier,
        };
      });

    const zip = zipper().combine((datum, sma, atr) => ({ datum, sma, atr }));

    const tuples = zip(data, smaCalculator(data), atrCalculator(data));
    return atrBandsAlgorithm(tuples);
  }

  calculator.undefinedLength = function () {
    const { windowSize } = options;
    return windowSize - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
